import apiFetch from '../apiFetch'

export default function (token, carlineId, includeDeleted = false) {
  const queryParamsArray = [
    `includeDeleted=${includeDeleted}`,
    carlineId ? `carlineId=${carlineId}` : null
  ]

  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )

  return apiFetch({ endPoint: 'catalogue' + queryParams, method: 'GET', body: null, token: token })
}
